type KEY = "token" | "USER";

export class LocalStorage {
    static setItem(key: KEY, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    static getItem(key: KEY)  {
        const data = localStorage.getItem(key);
        if(data) {
            return JSON.parse(data);
        }
        return null
    }
}